import { useTranslation } from 'react-i18next'

import Text from '../../../../Text'
import { RentalPortalMatchProvenanceDot } from '../../RentalPortalMatchProvenanceDot'

import * as styles from './RentalPortalMatchProvenanceLegendItem.module.css'

function RentalPortalMatchProvenanceLegendItem({ labelKey, source }) {
  const { t } = useTranslation()

  return (
    <Text className={styles.RentalPortalMatchProvenanceLegendItem}>
      <RentalPortalMatchProvenanceDot
        isTooltipDisabled
        provenance={{ source }}
      />
      {t(labelKey)}
    </Text>
  )
}

export default RentalPortalMatchProvenanceLegendItem
